var UserProfile = (function () {
    var full_name = "";

    var getUserdata = function () {
        var retrievedObject = localStorage.getItem('userData');
        return JSON.parse(retrievedObject);    // Or pull this from cookie/localStorage
    };

    var setUserdata = function (data) {
        localStorage.setItem('userData', JSON.stringify(data));
        // Also set this in cookie/localStorage
    };

    return {
        getUserdata: getUserdata,
        setUserdata: setUserdata
    }

})();

export default UserProfile;